import React from 'react';
import HomeDashboard from '../components/Homepage/HomeDashboard';
import './layout.css';

const Dashboard = ({ sidebarCollapsed, mobileSidebarOpen }) => {
  return (
    <div className={`page-container ${sidebarCollapsed ? 'sidebar-collapsed' : ''} ${mobileSidebarOpen ? 'mobile-sidebar-open' : ''}`}>
      <div className="page-content">
        <HomeDashboard />
      </div>
    </div>
  );
};

export default Dashboard;